import { useEffect } from 'react'

const useOutsideClick = (
  params = { dependency: null, ref: null, setClosed: null, setter: false }
) => {
  const { dependency, ref, setClosed, setter } = params

  const handleOutsideClick = (e) => {
    const allRefs = Array.isArray(ref) && ref.length > 0 ? ref : [ref]
    const clickedInside = allRefs.some(
      (r) => r?.current && r.current.contains(e.target)
    )

    if (!clickedInside) {
      setClosed(setter)
    }
  }

  useEffect(() => {
    if (dependency) {
      document.addEventListener('mousedown', handleOutsideClick)
    } else {
      document.removeEventListener('mousedown', handleOutsideClick)
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [dependency])
}

export default useOutsideClick
